import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7460db2a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "qrCodeLink"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qrcode_con"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "qrcode_img_active"
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "login_container"
})])], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    class: "schoolLogin",
    onClick: _cache[0] || (_cache[0] = $event => $options.zhsLogin())
  }, "智慧树账号登录"), _createElementVNode("div", {
    class: "resourceCloud",
    onClick: _cache[1] || (_cache[1] = $event => $options.jumpCloud())
  }, "数字化教育教学平台")]);
}